import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  signIn, signUp, signOut, validateUserToken, handleCreateNewWorkType,
  handleDeleteWorkType, handleCreateSuggestion,
  handleUserChangePassword, handleSendEmailResetPassword,
  handleResetPasswordWithEmail, handleUpdateWorkType, handleUpdateCompany, handleUpdateProfile, handleUpdateCostCategory,
  handleReorderWorkTypes,
  handleRecordOnboardingFlags,
  handleClearOnboardingFlag,
  handleDeleteProductGroup, handleCreateNewProductGroup, handleUpdateProductGroup,
} from '../actions/user';

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  signIn,
  signUp,
  signOut,
  validateUserToken,
  handleCreateSuggestion,
  handleCreateNewWorkType,
  handleDeleteWorkType,
  handleUserChangePassword,
  handleSendEmailResetPassword,
  handleResetPasswordWithEmail,
  handleUpdateWorkType,
  handleUpdateCompany,
  handleUpdateProfile,
  handleUpdateCostCategory,
  handleReorderWorkTypes,
  handleRecordOnboardingFlags,
  handleClearOnboardingFlag,
  handleDeleteProductGroup,
  handleCreateNewProductGroup,
  handleUpdateProductGroup,
}, dispatch);

const withUser = (WrappedComponent) => {
  class ConnectedComponent extends PureComponent {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(ConnectedComponent);
};

export default withUser;
